import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface LanguageState {
    language: string
    changeLanguage: (lang: string) => void
}

export const useLanguageStorage = create<LanguageState>()(
    persist(
        (set, get) => ({
            language: 'en',
            changeLanguage: (lang: string) => { set({ language: lang }) }
        }),
        {
            name: 'i18n-storage',
            storage: createJSONStorage(() => localStorage),
        },
    ),
)
